<template>
  <svg
    width="38"
    height="48"
    viewBox="0 0 38 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.912 31.3961H21.088V24.6864H27.8737V20.5572H21.088V13.8475H16.912V20.5572H10.1263V24.6864H16.912V31.3961ZM19 48C13.5366 46.3655 9.00419 43.0581 5.40279 38.0777C1.80093 33.0968 0 27.5166 0 21.3369V7.01904L19 0L38 7.01904V21.3369C38 27.5166 36.1991 33.0968 32.5972 38.0777C28.9958 43.0581 24.4634 46.3655 19 48ZM19 45.8012C23.9242 44.2392 27.9739 41.176 31.1491 36.6116C34.3244 32.0472 35.912 26.9556 35.912 21.3369V8.44351L19 2.17798L2.08796 8.44351V21.3369C2.08796 26.9556 3.67559 32.0472 6.85086 36.6116C10.0261 41.176 14.0758 44.2392 19 45.8012Z"
      fill="#383838"
    />
  </svg>
</template>
